export const [WEEK, WEEKPICKER] = ['week', 'WeekPicker'];
export const [MONTH, MONTHPICKER] = ['month', 'MonthPicker'];
export const [YEAR, YEARPICKER] = ['year', 'YearPicker'];
export const [QUARTER, QUARTERPICKER] = ['quarter', 'QuarterPicker'];
export const [TIME, TIMEPICKER] = ['time', 'TimePicker'];